import { useHistory, useLocation } from 'react-router';

import { Anchor, Button, Text } from '@zillow/constellation-10';
import { IconCloseOutline } from '@zillow/constellation-icons';
import QueryConstants from '../../../constants/QueryConstants';

export const NoSearchResults = ({
  showArchived,
  onRemoveSearchTextClick,
}: {
  showArchived: boolean;
  onRemoveSearchTextClick: (value: string) => void;
}) => {
  const history = useHistory();
  const location = useLocation();

  // Add postingPath query param to open the add property modal
  const handleAddPropertyClick = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(QueryConstants.POSTING_PATH, 'true');
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  return (
    <Text
      css={{
        textAlign: 'center',
        marginBottom: '800',
        padding: { sm: '0 400', lg: '0' },
      }}
    >
      No properties found for the following filters.
      {!showArchived && (
        <>
          {' '}
          Would you like to <Anchor onClick={handleAddPropertyClick}>post a listing</Anchor>?
        </>
      )}
      <br />
      <Button
        tone="brand"
        emphasis="outlined"
        size="sm"
        icon={<IconCloseOutline />}
        iconPosition="end"
        onClick={() => onRemoveSearchTextClick('')}
        css={{ marginTop: '200' }}
      >
        Remove search
      </Button>
    </Text>
  );
};
